import React, {Component} from 'react'
import TableComp from '../../../../components/_utils/table'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import {RightsWrapper} from '../../../../components/_utils/utils'

import moment from 'moment'
import {Button, Card, Row, Col, notification, Popconfirm, Tooltip} from 'antd'
import Request from '../../../../request'
import { Link } from "react-router-dom";

import {connect} from 'react-redux'
import styles from './styles.less'
import {getUrlPushWrapper} from '../../../../routes'
import commonStyle from '../../../common.less'

class AllKnowledgeBaseCategory extends Component {
    state = {count: 0, arr: [], list: [], loadList: false}

    constructor(props) {
        super(props)

        this.table = React.createRef()
    }

    apiRequest = params => {
        return new Promise(async resolve => {
            // params.count = 200
            params.sortField = 'name'
            params.sortOrder = !params.sortOrder ? 'ascend' : params.sortOrder
            let data = await Request.loadKnowledgeBaseCategory({
                ...params,
                regExFilters: ['name']
            })
            this.setState({count: data.total})
            resolve(data)
        })
    }

    handleDelete = (levelId) => {
        Request.deleteKnowledgeBaseCategory({_id: levelId})
            .then(x => {

                if (x.success) {
                    notification.success({
                        message: x.msg,
                        description: x.msg
                    })
                } else {
                    notification.error({
                        message: 'Error',
                        description: x.msg
                    })
                }
                this.table.current.reload()
            })
            .catch(err => {
                notification.error({
                    message: 'Error',
                    description: 'Some Error'
                })
            })
    }

    componentDidMount() {
    }

    render() {
        const {dispatch} = this.props

        const columns = [
            {
                title: 'Category Name',
                key: 'name',
                dataIndex: 'name',
                sorter: true,
                searchTextName: 'name',
                filterRegex: true
            },

            {
                title: 'Last Updated By',
                key: 'lastUpdatedByName',
                dataIndex: 'lastUpdatedByName',
                render: (text, record) => {
                    return (
                        <div>
                            <div
                                className={commonStyle.user}>{record.updatedByUser ? record.updatedByUser.name : record.createdByUser.name}</div>
                            <div>
                            {record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}
                            </div>
                        </div>
                    )
                }
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => (
                    <React.Fragment>
                        <RightsWrapper myRight={'Category.edit'}>
                            <Tooltip title="Edit Details">
                                <Button
                                    className={styles.btn}
                                    shape="circle"
                                    onClick={() => {
                                        dispatch(
                                            getUrlPushWrapper('knowledge-base.edit-category', {_id: record._id})
                                        )
                                    }}
                                    icon="edit"
                                />
                            </Tooltip>
                        </RightsWrapper>
                        <RightsWrapper myRight={'Category.delete'}>
                            <Tooltip title="Delete Category">
                                <Popconfirm
                                    title="Are you sure to delete Category?"
                                    onConfirm={() => this.handleDelete(record._id)}
                                    okText="Yes"
                                    cancelText="No">
                                    <Button
                                        shape="circle"
                                        className={styles.btn}
                                        icon="delete"/>
                                </Popconfirm>
                            </Tooltip>
                        </RightsWrapper>
                    </React.Fragment>
                )
            }
        ]
        return (
            <PageHeaderWrapper title={`Knowledge Base Category : ${this.state.count} `}>
                <Card bordered={true}>
                    <Row>
                        <Col span={22}></Col>
                        <Col span={2}>
                            <div style={{textAlign: 'right', marginTop: '15px'}}>
                                <Link to='/knowledgebase/add-category'><Button>Add</Button></Link>
                            </div>
                        </Col>
                    </Row>
                    <TableComp
                        columns={columns}
                        apiRequest={this.apiRequest}
                        ref={this.table}/>
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global}) => ({
    categories: global.categories
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AllKnowledgeBaseCategory)
